/* eslint-disable vue/component-name-in-template-casing */
import { IMPROVE_CONFIG } from "@/config.js";

export default {
  setPagingParams: function(pagingObj, meta) {
    pagingObj.page = meta.pagination.current_page;
    pagingObj.rowsPerPage = meta.pagination.per_page;
    pagingObj.totalItems = meta.pagination.total;
    pagingObj.totalPages = meta.pagination.total_pages;
    pagingObj.next = meta.pagination.links.next;
    pagingObj.prev = meta.pagination.links.previous;
    return pagingObj;
  },
  getQueryString: function(p,m) {
    if(p.sortDesc){
    let direction = p.sortDesc[0] == true ? "&sortedBy=desc" : "&sortedBy=asc";
    let sortBy = "&orderBy=" + p.sortBy;
    let page = "?page=" + p.page;
    let limit =
      p.itemsPerPage === -1 ? "&limit=" + m : "&limit=" + p.itemsPerPage;
    let queryParams = page + sortBy + direction + limit;
    return queryParams;
    }
    return '';
  },
  errorResponse: function(err) {
    let errors = err.response.data.errors;
    let messages = [];
    if (errors) {
      for (let field in errors) {
        messages[field] = errors[field];
      }
    }
    return messages;
  },
  getQueryStringNew: function(p,m) {
    
    let direction = "&sortedBy=desc";
    let sortBy = "&orderBy=id";
    let page = "?page=" + p.page;
    let limit =
      p.itemsPerPage === -1 ? "&limit=" + m : "&limit=" + p.itemsPerPage;
    let queryParams = page + sortBy + direction + limit;
    return queryParams;
  },
  removeBackdrop(){
    const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
  },
  headerColor() {
    return 'primary';
    if (IMPROVE_CONFIG.APP_NAME === 'senso') {
      return 'header';
    } else if (IMPROVE_CONFIG.APP_NAME === 'partner') {
      return 'partnerHeader';
    } else {
      return 'directHeader';
    }
  },
  truncateText(text, maxLength) {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  },
};
